import { useQuery } from '@tanstack/react-query';
import { format, startOfMonth } from 'date-fns';
import { supabase } from '@/integrations/supabase/client';

import { fetchDeflatorCancelamentoLote as buscar, type DeflatorLote } from '../../../../backend/src/domain/comissao/DeflatorCancelamentoLote';
export * from '../../../../backend/src/domain/comissao/DeflatorCancelamentoLote';
export const fetchDeflatorCancelamentoLote = (competencia: Date) => buscar(competencia, supabase);
import { fetchProdutosFaturamento as buscarProdutos } from '../../../../backend/src/domain/comissao/DeflatorCancelamentoLote';
export const fetchProdutosFaturamento = () => buscarProdutos(supabase);
export function useDeflatorCancelamentoLote(competencia: Date, enabled = true) {
  const mes = format(startOfMonth(competencia), 'yyyy-MM');
  return useQuery<DeflatorLote>({
    queryKey: ['deflator-cancelamento-lote', mes],
    enabled,
    staleTime: 5 * 60 * 1000,
    gcTime: 15 * 60 * 1000,
    refetchOnWindowFocus: false,
    placeholderData: (prev) => prev,
    queryFn: () => fetchDeflatorCancelamentoLote(competencia),
  });
}
